import { ReactNode, useMemo } from 'react';

import { useJobQuoteContext } from 'components/JobQuote/context';
import { ChevronDown } from 'lucide-react';

export interface ButtonWrapperProps {
  onClick?: () => void;
  iconClassName?: string;
}

export interface WrapperProps extends ButtonWrapperProps {
  children: ReactNode;
}

export const DivWrapper: React.FunctionComponent<WrapperProps> = function ({
  children,
}) {
  const { variant } = useJobQuoteContext();
  const wrapperClassName = useMemo(
    () =>
      [
        'bg-neutral-900 px-4 py-3 grid grid-cols-[1fr_auto] gap-y-1 gap-x-3 text-neutral-000',
        variant !== 'full' ? '' : 'md:px-6 md:py-5 sm:grid-cols-[auto_1fr] ',
      ].join(' '),
    [variant],
  );
  return <div className={wrapperClassName}>{children}</div>;
};

export const ButtonWrapper: React.FunctionComponent<WrapperProps> = function ({
  children,
  onClick,
  iconClassName,
}) {
  const { variant } = useJobQuoteContext();
  const wrapperClassName = useMemo(
    () =>
      [
        'flex flex-row bg-neutral-900 px-4 py-3 gap-x-3 text-neutral-000',
        variant !== 'full' ? '' : ' md:px-6 md:py-5',
      ].join(' '),
    [variant],
  );
  const gridClassName = useMemo(
    () =>
      [
        'w-full gap-y-1 gap-x-3 text-left grid',
        variant !== 'full'
          ? 'grid-cols-[min-content_auto]'
          : 'grid-cols-[min-content_auto] sm:grid-cols-[auto_1fr]',
      ].join(' '),
    [variant],
  );
  return (
    <button onClick={onClick} type="button" className={wrapperClassName}>
      <div className={gridClassName}>{children}</div>
      <ChevronDown className={iconClassName ?? ''} />
    </button>
  );
};
